export class BaseClass {
    AddedDate :Date ;
    ModifiedDate :Date;
    IPAddress :string
    AddUserId :number
    ModifyUserId :number
}